import * as React from 'react';

import {requestGeolocation} from '~/modules/App/store/geoActions';
import {MODAL_REQUEST_GEO_LOCATION} from '~/rootStore/modals/modalsIds';
import useModalById from '~/customHooks/useModalById';
import useLoader from '~/customHooks/useLoader';
import {LOADER_REQUEST_GEOLOCATION} from '~/modules/CurrentUser/Settings/constants/loadersIds';

import image from './img/allow-location-icon.svg';
import ModalBaseContent from '../ModalBaseContent';
import ModalBase from '../ModalBase';

const ModalAllowLocation: React.FC = () => {
  const modalRequestGeoLocation = useModalById(MODAL_REQUEST_GEO_LOCATION);

  const {isLoading} = useLoader(LOADER_REQUEST_GEOLOCATION);
  const handleActionClick = () => {
    requestGeolocation();
  };

  return (
    <ModalBase open={modalRequestGeoLocation.isOpen} onClose={modalRequestGeoLocation.close}>
      <ModalBaseContent
        p={2}
        image={image}
        title="Allow location access"
        description="To get access to chat and extra features you have to accept location requests made by application."
        actionButtonText="OK"
        isLoading={isLoading}
        onClickActionButton={handleActionClick}
      />
    </ModalBase>
  );
};

export default ModalAllowLocation;
